<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="truckComponent" [formGroup]="gpsAddForm">
  <div class="accordion-class">
    <h5 *ngIf="data.type === 'New'">Add GPS Device</h5>
    <h5 *ngIf="data.type === 'Edit'">Edit GPS Device</h5>

    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <h6>Device Details</h6>
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Device Referenceno:</mat-label>
            <input matInput formControlName="device_reference_no" required />
            <mat-error>Please Enter Device Reference Number</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6 trucksselect mt-2">
          <mat-form-field appearance="fill">
            <mat-label>Request Type:</mat-label>
            <mat-select
              dropLocationSearchField
              formControlName="request_type"
              required
            >
              <mat-option *ngFor="let cat of GpsTypeData" value="{{ cat._id }}">
                {{ cat.server_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <h6>Device SIM details</h6>
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Provider:</mat-label>
            <input matInput formControlName="provider" required />
            <mat-error>Please Enter Provider</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Contact no:</mat-label>
            <input
              matInput
              formControlName="contact_no"
              minlength="10"
              maxlength="10"
              required
              (keypress)="validateNumber($event)"
            />
            <mat-error>Please Enter Valid contact Number</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Plan Information:</mat-label>
            <input matInput formControlName="plan_information" required />
            <mat-error>Please Enter Plan Information</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-datepicker #picker></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Expiry Date"
              [min]="minDate"
              formControlName="expiry_date"
              (click)="picker.open()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <!-- <button type="button" (click)="addGPS()" class="button buttonBlue">Submit
    </button> -->
  <button
    [class.spinner]="loading"
    [disabled]="loading"
    *ngIf="data.type === 'New'"
    type="button"
    class="button buttonBlue"
    (click)="addGPS()"
  >
    Submit
  </button>
  <button
    [class.spinner]="loading"
    [disabled]="loading"
    *ngIf="data.type === 'Edit'"
    type="button"
    class="button buttonBlue"
    (click)="EditGps()"
  >
    Submit
  </button>
</form>
